import { CellProps } from '../../../types';
import { Box, HStack } from '@chakra-ui/react';
import { ENROLY_AGENT_ROLES, UNI_ROLES, UserRole } from '../../../../../../store/auth/types';

export const StudentNumber = ({
  cellProps,
  role,
  isPathway,
}: {
  cellProps: CellProps;
  role: UserRole;
  isPathway?: boolean;
}) => {
  const isPathwayStudent = !!cellProps.row.pathway;
  const isSearch = cellProps.row.isSearch!;

  const uniId = cellProps.row.uniPartnerId;
  const pathwayId = cellProps.row.student_number;

  const isUniUser = [...UNI_ROLES, ...ENROLY_AGENT_ROLES].includes(role);

  let mainId;
  let secondaryId;
  const has2Ids = !!uniId && !!pathwayId;

  if (isSearch) {
    mainId = isPathway ? pathwayId : uniId;
    secondaryId = isPathway ? uniId : pathwayId;
  } else {
    const getStudentNumberForPathwayStudent = () => {
      if (isPathway) {
        return pathwayId;
      }
      if (isUniUser) {
        return has2Ids ? uniId! : pathwayId;
      }
      return pathwayId;
    };

    mainId = pathwayId;

    if (isPathwayStudent) {
      mainId = getStudentNumberForPathwayStudent();
    }
  }

  return (
    <HStack spacing="1" fontWeight="medium">
      <Box>{mainId}</Box>

      {secondaryId && (has2Ids ? <Box color="muted">({secondaryId})</Box> : <Box>{secondaryId}</Box>)}
    </HStack>
  );
};
